/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "enigma": {
        "nested": {
          "service": {
            "nested": {
              "ReaderInfo": {
                "fields": {
                  "readerType": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "readerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "swipeId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "counter": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isDuplicateSwipe": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "hardwareSerialNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "readerFirmwareVersion": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "counterOffset": {
                    "type": "sint64",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.enigma?.nested?.service?.nested?.ReaderInfo) {
  $root.addJSON(jsonData);
}

/**
 * Reader information.
 *
 * SOURCE ReaderInfo @ squareup/enigma/service.proto at 170:1
 */
export const ReaderInfo = $root.lookupType('squareup.enigma.service.ReaderInfo');
fixType(ReaderInfo);
Builder.createAndAttachToType(ReaderInfo);